import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import LoadingScreen from './components/LoadingScreen';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Who from './components/Who';
import Vision from './components/Vision';
import FromSite from './components/FromSite';
import BuiltForCertainty from './components/BuiltForCertainty';
import LandownerPartnerships from './components/LandownerPartnerships';
import ValueWithoutComplexity from './components/ValueWithoutComplexity';
import PoweringDemand from './components/PoweringDemand';
import Footer from './components/Footer';
import ScrollIndicator from './components/ScrollIndicator';
import EverfieldEnergy from './components/EverfieldEnergy';
import EverfieldDC from './components/EverfieldDC';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

let hasLoadedOnce = false;

function HomePage() {
  const [loaded, setLoaded] = useState(hasLoadedOnce);
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash || !loaded) return;
    const id = hash.slice(1);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [hash, loaded]);

  return (
    <div className="App">
      {!hasLoadedOnce && (
        <LoadingScreen onDone={() => { hasLoadedOnce = true; setLoaded(true); }} />
      )}
      <div style={loaded ? undefined : { visibility: 'hidden', pointerEvents: 'none' }}>
        <ScrollIndicator />
        <Hero />
        <Navbar />
        <Who />
        <Vision />
        <FromSite />
        <BuiltForCertainty />
        <LandownerPartnerships />
        <ValueWithoutComplexity />
        <PoweringDemand />
        <Footer />
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/everfield-energy" element={<EverfieldEnergy />} />
        <Route path="/everfield-dc" element={<EverfieldDC />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
